import ResponseTypeMaster from '../responseTypeMaster';

function ResponseTypeMasterPage() {
  return <ResponseTypeMaster />;
}

export default ResponseTypeMasterPage;
